module.exports = __webpack_public_path__ + "img/startPoint.693fe255.png";